import Vue from 'vue';
import VueI18n from 'vue-i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

import messages from './locales/fr.json';

Vue.use(VueI18n);
dayjs.locale('fr');

const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  messages,
});

export default i18n;
